import Usage from '@amplify/amp-usage-service-lib';

import { Environment, USAGE_TAGS } from 'root/lib/constants';
import Env from './Env';

const { isDevEnv } = Env;
const { DEVCI } = Environment;
const ENVIRONMENT = isDevEnv ? DEVCI : EnvSettings.ENVIRONMENT;

const deverror = isDevEnv ? console.error : () => {};

export default class UsageService {
  static isInitialized = false;

  static init({
    ampId,
    env = ENVIRONMENT,
    initTags = [
      `${USAGE_TAGS.PROGRAM_USE.prefix}: ${USAGE_TAGS.PROGRAM_USE.value}`,
      `${USAGE_TAGS.SUITE.prefix}: ${USAGE_TAGS.SUITE.value}`,
    ],
    interval = 60,
  }) {
    try {
      Usage.init({
        [Usage.OPTIONS.USER_ID]: ampId,
        [Usage.OPTIONS.ENVIRONMENT]: env,
        // NOTE: the AmpEvents library converts strings (including these tags) into kebab-case
        [Usage.OPTIONS.TAGS]: initTags,
        [Usage.OPTIONS.INTERVAL]: interval, // seconds
        [Usage.OPTIONS.IDLE_DETECTION]: true,
      });
      this.isInitialized = true;
    } catch (e) {
      console.error('Error initializing Usage service', e);
    }
  }

  static setTags(tags) {
    if (!tags || !Array.isArray(tags)) {
      deverror('setTags expects an array of tags, but received:', typeof tags, tags);
      return;
    }

    try {
      Usage.setTags(tags);
    } catch (e) {
      console.error('Error setting tags', tags, e);
    }
  }

  // Stop Usage on logout only if successfully initiated
  static stopUsage() {
    if (this.isInitialized) {
      Usage.stop();
      this.isInitialized = false;
    }
  }
}
